/**
 * 던지기 궤적 보조선 (FR-003, 모바일 온보딩 원칙 II).
 * 예상 속도로 중력 하 포물선을 미리 그린다.
 */
import * as THREE from 'three';

const STEPS = 26;
const DT = 0.045;
const GRAVITY = -9.81;

export class TrajectoryGuide {
  private line: THREE.Line;
  private positions: Float32Array;

  constructor(scene: THREE.Scene) {
    this.positions = new Float32Array(STEPS * 3);
    const geom = new THREE.BufferGeometry();
    geom.setAttribute('position', new THREE.BufferAttribute(this.positions, 3));
    const mat = new THREE.LineDashedMaterial({
      color: 0xffe066,
      dashSize: 0.08,
      gapSize: 0.06,
      transparent: true,
      opacity: 0.85,
    });
    this.line = new THREE.Line(geom, mat);
    this.line.frustumCulled = false;
    this.line.visible = false;
    scene.add(this.line);
  }

  show(from: THREE.Vector3, vel: THREE.Vector3): void {
    for (let i = 0; i < STEPS; i++) {
      const t = i * DT;
      this.positions[i * 3] = from.x + vel.x * t;
      this.positions[i * 3 + 1] = from.y + vel.y * t + 0.5 * GRAVITY * t * t;
      this.positions[i * 3 + 2] = from.z + vel.z * t;
    }
    this.line.geometry.attributes.position.needsUpdate = true;
    this.line.computeLineDistances();
    this.line.visible = true;
  }

  hide(): void {
    this.line.visible = false;
  }
}
